import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
import React, { forwardRef } from "react";
import { cellClickedHandler, getDataPath, getRowId, rowClassRules } from "../Roster/RosterGuestList";
import { autoGroupColumnDef, defaultColDef } from "../Roster/RosterGuestList/helpers";
import { getRowHeight } from "./gridUtils";
import { useDashboardFilterStore } from "@/stores/dashboardFilterStore";

export const GroupedTableWrapper = forwardRef<AgGridReact, AgGridReactProps>((props, ref) => {
    const { expandAllRows } = useDashboardFilterStore((state) => state.displayOptions);

    const isRowGroupOpenByDefault = () => {
        return expandAllRows;
    };

    return (
        <AgGridReact
            ref={ref}
            suppressCellFocus
            suppressContextMenu
            suppressRowHoverHighlight
            suppressNoRowsOverlay
            tooltipMouseTrack
            treeData
            suppressScrollOnNewData
            animateRows={false}
            suppressAnimationFrame={false}
            theme="legacy"
            domLayout="normal"
            rowBuffer={15}
            groupDefaultExpanded={0}
            defaultColDef={defaultColDef}
            isGroupOpenByDefault={isRowGroupOpenByDefault}
            autoGroupColumnDef={autoGroupColumnDef}
            rowClassRules={rowClassRules}
            getRowId={getRowId}
            getDataPath={getDataPath}
            getRowHeight={getRowHeight}
            onCellClicked={cellClickedHandler}
            {...props}
        />
    );
});
